import { AuthGuard } from '@consigli/oauth';
import { Auth } from '@consigli/oauth';
import {
  createBrowserRouter,
  createRoutesFromElements,
  Navigate,
  Outlet,
  Route,
} from 'react-router';

import { BackofficeRoutes } from '@/route-names';
import { authConfig } from '@/utils/oauth/config';

import { BeamstarPage } from './pages/beamstar/beamstar-page';
import { DashboardPage } from './pages/dashboard/dashboard-page';
import { AccessDenied } from './pages/layout/access-denied';
import { AdminGuard } from './pages/layout/admin-guard';
import { CheckingAuthorization } from './pages/layout/checking-authorization';
import { Layout } from './pages/layout/layout';
import { OrganizationsPage } from './pages/organizations/organizations-page';
import { ProjectPage } from './pages/project/project-page';
import { ProjectsPage } from './pages/projects/projects-page';
import { ReportTemplatesPage } from './pages/report-templates';
import { BuildingPackagePage } from './pages/services/building-package-page';
import { DocumentPackagePage } from './pages/services/document-package-page';
import { LayoutOptimizationPage } from './pages/services/layout-optimization-page';
import { UsersPage } from './pages/users/users-page';

export const routes = createRoutesFromElements(
  <>
    <Route
      path="/"
      element={
        <AuthGuard authConfig={authConfig} loading={<CheckingAuthorization />}>
          <AdminGuard>
            <Layout />
          </AdminGuard>
        </AuthGuard>
      }
    >
      <Route index element={<DashboardPage />} />
      <Route path={BackofficeRoutes.PROJECTS} element={<Outlet />}>
        <Route index element={<ProjectsPage />} />
        <Route path=":projectId" element={<ProjectPage />} />
        <Route path=":projectId/Packages/:packageId" element={<DocumentPackagePage />} />
        <Route path=":projectId/Layouts/:layoutId" element={<LayoutOptimizationPage />} />
        <Route path=":projectId/Buildings/:buildingPackageId" element={<BuildingPackagePage />} />
      </Route>
      <Route path={BackofficeRoutes.ORGANIZATIONS} element={<Outlet />}>
        <Route index element={<OrganizationsPage />} />
      </Route>
      <Route path={BackofficeRoutes.USERS} element={<Outlet />}>
        <Route index element={<UsersPage />} />
      </Route>
      <Route path={BackofficeRoutes.REPORT_TEMPLATES} element={<Outlet />}>
        <Route index element={<ReportTemplatesPage />} />
      </Route>
      <Route path={BackofficeRoutes.BEAMSTAR} element={<Outlet />}>
        <Route index element={<BeamstarPage />} />
      </Route>
    </Route>

    <Route path="access-denied" element={<AccessDenied />} />
    <Route path="logout" element={<Navigate to="/" />} />
    <Route path="auth" element={<Auth destination="/" authConfig={authConfig} />} />

    {/* Redirect old /new/* routes to root */}
    <Route path="new/*" element={<Navigate to="/" replace />} />
  </>,
);

export const router = createBrowserRouter(routes);
